import React from 'react'

import { MobXProviderContext, observer } from 'mobx-react'

import DesktopInitialState from '~/client/src/desktop/stores/DesktopInitialState'
import ProjectSetupResourceProperties from '~/client/src/desktop/views/ProjectSetUp/components/ProjectSetupResourceConfig/ResourceProperties/ProjectSetupResourceProperties'
import { ResourceTypeId } from '~/client/src/shared/constants/resourceTypes'
import { LocalStorageKey } from '~/client/src/shared/enums/LocalStorageKey'
import { useMaterialResourceStore } from '~/client/src/shared/hooks/useMaterialResourceStore'

function MaterialResourcesProperties(): React.ReactElement {
  const { state } = React.useContext(MobXProviderContext) as {
    state: DesktopInitialState
  }
  const { schema } = useMaterialResourceStore(state.activeProject?.id)

  return (
    <ProjectSetupResourceProperties
      resourceTypeId={ResourceTypeId.MATERIALS}
      columnConfigKey={LocalStorageKey.MaterialsPropertiesColumnConfig}
      resourceSchema={schema}
    />
  )
}

export default observer(MaterialResourcesProperties)
